module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1047-f97f03c5a87998d55fcf47549c24edbc.png";